import captureException from 'src/common/utils/captureException';
// TODO: This is a clunky way of doing conditional import.
// Remove once Sentry introduces a universal import, or
// otherwise refactor, maybe using null-loader?
const Sentry = process.env.BROWSER ? require('@sentry/browser') : require('@sentry/node');

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const fetchCatch = (response: Response | unknown) => {
  if (response instanceof Response) {
    captureException(new Error('Response Thrown'), {
      extra: {
        url: response.url,
        status: response.status,
        type: response.type,
      },
    });
  }
  // TODO: make this return useful information.
};

export const { configureScope } = Sentry;
